<style lang="scss" scoped>
.footBar {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 99;
  width: 100%;
  min-width: 1200px;
  background: #f2fbff;
  border: 1px solid #ccecff;
  .subBox {
    display: flex;
    margin: 24px 120px;
    height: 60px;
    background: #ffffff;
    border-radius: 2px;
    padding: 0 24px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #111111;
    border-top: solid 1px #f0f2f5;
    justify-content: space-between;
    line-height: 60px;

    .text {
    }
  }
  .bar {
    display: -webkit-box;
    // justify-content: space-between;
    width: 1000px;
    height: 66px;
    margin: 0 auto;
    .desc {
      padding-top: 6px;
      font-size: 18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #1890ff;
      margin-right: 110px;
      .warning {
        color: #f8841f;
      }
      &_m {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
      }
    }
  }
  .icon {
    color: #2083e0;
    font-size: 36px;
    color: #2083e0;
    margin-left: 90px;
    line-height: 66px;
    margin-right: 36px;
  }
  .btn {
    line-height: 66px;
    margin-right: 260px;
  }
}
</style>
<template>
  <div class="footBar">
    <div class="bar">
      <div>
        <i class="el-icon-bell icon" />
      </div>
      <div class="desc">
        <div>
          提示：因API限制，目前配置流程非常复杂，
          <span class="warning">不建议自行配置</span>
        </div>
        <div class="desc_m">
          建议联系云店客服，让客服帮您进行配置，全程一对一服务
        </div>
      </div>
      <div class="btn">
        <el-button
          type="warning"
          size="mini"
          @click="$router.push({ path: '/qwAuth/bindCS' })"
        >
          联系客服进行配置
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'FootBar',
  props: {
    title: {
      type: String,
      default: '还没有企业微信'
    },
    desc: {
      type: String,
      default: '5分钟立即注册带有导购生意助手的企业微信'
    },
    callFun: {
      type: Function,
      default: (res) => {
        console.log('callFun', res)
        return res
      }
    },
    images: {
      type: String,
      default: 'https://b-uat.jusstickets.com//static/img/logo2.e0ee6fe.jpg'
    }
  },
  data () {
    return {}
  },
  watch: {},
  mounted () {},
  methods: {}
}
</script>
